import { render, staticRenderFns } from "./default.vue?vue&type=template&id=640511c9&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=640511c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBar: require('/var/www/pb-store/components/NavBar.vue').default,TabBar: require('/var/www/pb-store/components/TabBar.vue').default,Foot: require('/var/www/pb-store/components/Foot.vue').default})
